import { Component, inject } from '@angular/core';
import { ApplicationCommonComponent } from '../../../common/application.common.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { stages } from '../../contact-data-update.routes';
import { ContractDataUpdateOtherDataForm } from './forms/contact-data-update-other-data.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-contact-data-update-other-data-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent
  ],
  providers: [ContractDataUpdateOtherDataForm],
  templateUrl: './contact-data-update-other-data-section.component.html'
})
export class ContactDataUpdateOtherDataSectionComponent extends ApplicationCommonComponent {

  public stages = stages;

  public successUrl: string = this.route.snapshot.data['successUrl'];

  public form: ContractDataUpdateOtherDataForm = inject(ContractDataUpdateOtherDataForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.updateApplication(this.successUrl.replaceAll('../', ''), this.form.toWriteModel());
    } else {
      this.form.markAllAsTouched();
    }
  }
}
